import { HTMLVideoLoader } from "../helpers/video";

const SHOW_CLASS = 'show';
const CONTROLS_ATTRIBUTE = 'controls';

/**
 * A class that handles the play/pause button of a brand video
 * (uploaded video with branded play button)
 */
export class BrandVideo {
    private playBtn: HTMLElement;
    private video: HTMLElement;

    constructor(videoContainer: HTMLElement) {
        const video = videoContainer.querySelector('video') as HTMLVideoElement;
        if (!video) {
            return;
        }
        this.video = video;
        const videoLoader = new HTMLVideoLoader(video);
        this.playBtn = videoContainer.querySelector('[data-play-btn]') as HTMLElement;
        this.onPlay = this.onPlay.bind(this);
        this.onPause = this.onPause.bind(this);

        if (this.playBtn) {
            videoLoader.setOnPlay(this.onPlay);
            videoLoader.setOnPause(this.onPause);
            this.playBtn.classList.add(SHOW_CLASS);
            this.playBtn.addEventListener('click', () => {
                videoLoader.play()
            });
        }
    }

    onPlay() {
        if (!this.playBtn) {
            return;
        }
        this.playBtn.classList.remove(SHOW_CLASS);
        this.toggleNativeControl();
    }

    onPause() {
        if (!this.playBtn) {
            return;
        }
        this.toggleNativeControl();
        this.playBtn.classList.add(SHOW_CLASS);
    }

    private toggleNativeControl() {
        if (!this.video) {
            return;
        }
        if (this.video.hasAttribute(CONTROLS_ATTRIBUTE)) {
            this.video.removeAttribute(CONTROLS_ATTRIBUTE);
        } else {
            this.video.setAttribute(CONTROLS_ATTRIBUTE, 'true');
        }
    }
}
